import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { User } from 'src/app/shared/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserListService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  public resolveUsers(filter: string, offset: number, limit: number): Observable<object>
  {
    if (filter === '') {
      return this.getAllUsers(offset, limit);
    } else {
      return this.getFilteredUsers(filter, offset, limit);
    }
  }

  /**
   *
   */
  private getAllUsers(offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/users`, { responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  private getFilteredUsers(filter: string, offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('filter', filter)
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/users/search`, { responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   * @param user
   */
  create(user: User) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .post(`${this.url}/users`, user, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param user
   */
  update(user: User) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .put(`${this.url}/users`, user, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param id
   */
  delete(id: number) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .delete(`${this.url}/users/${id}`, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error.error);
  }
}
